import React from 'react';
import PropTypes from 'prop-types';
import { Collapsible } from '@spotahome/ui-library';
import classNames from 'classnames';

import './FAQAccordionItem.scss';

const themes = {
  landlord: 'landlord',
  tenant: 'tenant'
};

const FAQAccordionItem = ({
  top,
  content,
  isOpened,
  theme,
  onCollapsedChange
}) => {
  const topCN = classNames(
    'faq-accordion-item__top',
    `faq-accordion-item__top--${themes[theme]}`
  );
  return (
    <div className="faq-accordion-item">
      <Collapsible
        renderHeader={() => <div className={topCN}>{top}</div>}
        renderBody={() => (
          <div
            className="faq-accordion-item__content"
            dangerouslySetInnerHTML={{ __html: content }}
          />
        )}
        hasIcon
        isCollapsed={!isOpened}
        onCollapsedChange={onCollapsedChange}
      />
    </div>
  );
};

FAQAccordionItem.themes = themes;

FAQAccordionItem.propTypes = {
  top: PropTypes.node.isRequired,
  content: PropTypes.node.isRequired,
  isOpened: PropTypes.bool,
  theme: PropTypes.oneOf(Object.keys(themes)),
  onCollapsedChange: PropTypes.func
};

FAQAccordionItem.defaultProps = {
  isOpened: false,
  theme: 'landlord',
  onCollapsedChange: () => {}
};

export default FAQAccordionItem;
